import { render, staticRenderFns } from "./AddSingle.vue?vue&type=template&id=182d8412&scoped=true&"
import script from "./AddSingle.vue?vue&type=script&lang=js&"
export * from "./AddSingle.vue?vue&type=script&lang=js&"
import style0 from "./AddSingle.vue?vue&type=style&index=0&id=182d8412&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d8412",
  null
  
)

export default component.exports